import React from "react";

import { styled } from "@mui/material";
import { getFontWeightAndStyle } from "@src/formatters";

import { useProgressBarContext } from "../../../context/ProgressBarContext";

export const BreakpointLabels = () => {
  const { state } = useProgressBarContext();
  return (
    <Container className={"ig-labels"}>
      {state.breakpoints.map((b, index) => {
        return (
          <Label key={index} className={"ig-label"}>
            {b.label ?? ""}
          </Label>
        );
      })}
    </Container>
  );
};

const Container = styled("div")({
  display: "flex",
  marginBottom: "10px",
});

const Label = styled("div")(() => {
  const { config } = useProgressBarContext();
  const { fontWeight, fontStyle } = getFontWeightAndStyle(
    config.desktop.widget.styles.typography.breakpointText.fontStyle
  );
  const fontSize =
    config.desktop.widget.styles.typography.breakpointText.fontSize;
  return {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    whiteSpace: "normal",
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight: "14px",
    userSelect: "none",
  };
});
